const enc = new TextEncoder();
const hex = (buf) => [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");

export async function verifyCup(seed, roundId) {
  const sha = hex(await crypto.subtle.digest("SHA-256", enc.encode(seed)));
  const key = await crypto.subtle.importKey("raw", enc.encode(seed), { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);
  const h = hex(await crypto.subtle.sign("HMAC", key, enc.encode(roundId)));
  return { sha, cup: Number(BigInt("0x" + h) % 3n) };
}
